import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App.vue'
import router from './router'
import store from './store'

Vue.use(ElementUI)

Vue.prototype.$langStore = {
  currentLang: localStorage.getItem('app_lang') || 'zh',
  dict: {
    zh: {
      platformTitle: "智能康复医学教学平台",
      home: "首页",
      about: "关于",
      logout: "退出登录",
      courseTitle: "口腔癌术后康复课程",
      lesson1: "术后基础知识",
      lesson2: "术后急性期管理",
      lesson3: "亚急性期康复",
      lesson4: "居家康复指导",
      vpPage: "虚拟病人交互",
      discussion: "讨论区",

      caseTitle:"病例信息",
      case01Label:"病例1：术后亚急性期",
      case02Label:"病例2：术后急性期",
      case03Label:"病例3：出院规划社区回归",
      baseInfo:"基本信息",
      chiefComplaint:"主诉",
      presentHistory:"现病史",
      operationMethod:"手术方式",
      currentStage:"当前阶段",
      tipText:"苏格拉底式问诊，和临床带教导师进行交互评估，需要你提出问题并阐述推理依据，获取患者评估资料。",
      roleStudent:"学生",
      roleTutor:"临床带教老师",
      inputPlaceholder:"请输入你的问诊内容",
      btnSending:"发送中...",
      btnSend:"发送"
    },
    en: {
      platformTitle: "Intelligent Rehabilitation Medical Teaching Platform",
      home: "Home",
      about: "About",
      logout: "Logout",
      courseTitle: "Oral Cancer Post‑operative Rehabilitation Course",
      lesson1: "Basic Post‑operative Knowledge",
      lesson2: "Acute Post‑operative Management",
      lesson3: "Sub‑acute Rehabilitation",
      lesson4: "Home‑based Rehabilitation Guidance",
      vpPage: "Virtual Patient Interaction",
      discussion: "Discussion Forum",

      caseTitle:"Case Information",
      case01Label:"Case1: Sub‑acute post‑operative phase",
      case02Label:"Case2: Acute post‑operative phase",
      case03Label:"Case3: Discharge & community reintegration",
      baseInfo:"Basic Info",
      chiefComplaint:"Chief Complaint",
      presentHistory:"Present Illness",
      operationMethod:"Surgical Procedure",
      currentStage:"Current Phase",
      tipText:"Socratic dialogue with clinical tutor. Ask questions and provide reasoning to obtain patient assessment data.",
      roleStudent:"Student",
      roleTutor:"Clinical Tutor",
      inputPlaceholder:"Enter your inquiry",
      btnSending:"Sending...",
      btnSend:"Send"
    }
  }
}

Object.defineProperty(Vue.prototype, '$i18n', {
  get() {
    return this.$langStore.dict[this.$langStore.currentLang]
  }
})

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
